module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-box",
    class: _vm.demos.length ? 'components-with-toc' : ''
  }, [_c('div', {
    class: _vm.demos.length ? 'component-header-v2' : 'component-header-v1'
  }, [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("Spinner")]), _c('div', {
    staticClass: "title-box"
  }, [(_vm.isBeta) ? _c('el-badge', {
    attrs: {
      "value": "Beta"
    }
  }, [_c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Spinner")])]) : _c('h1', {
    staticClass: "vux-component-name"
  }, [_vm._v("Spinner")]), _c('p', {
    staticClass: "component-extra-links"
  }, [_c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org/#/component/spinner",
      "target": "_blank"
    }
  }, [_vm._v("demo url")]), (!_vm.demos.length) ? _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Spinner.vue",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSourceCode($event)
      }
    }
  }, [_vm._v("demo source code")]) : _vm._e(), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/spinner/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("edit document")]), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/spinner/",
      "target": "_blank"
    }
  }, [_vm._v("component source code")]), (_vm.hasReady) ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "width": "100",
      "src": "https://qr.vux.li/api.php?text=https%3A%2F%2Fvux-demos.bobjoy.eu.org%2F%23%2Fcomponent%2Fspinner"
    }
  })]), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    slot: "reference"
  }, [_vm._v("\n              view demos on mobile\n              ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "component-description"
  }, [(false) ? void 0 : _vm._e()], 2)], 1), (!_vm.demos.length) ? _c('div', {
    staticClass: "component-demo",
    staticStyle: {
      "width": "377px",
      "height": "600px",
      "display": "inline-block",
      "border": "1px solid #ececec",
      "border-radius": "5px",
      "overflow": "hidden",
      "z-index": "2500"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux-demos.bobjoy.eu.org?locale=en&transition=none/#/component/spinner",
      "width": "375",
      "height": "600",
      "border": "0",
      "frameborder": "0"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "toc"
  }, _vm._l((_vm.toc), function(t) {
    return _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": '#' + (t.anchor || t.title)
      }
    }, [_vm._v(_vm._s(t.title))]), _vm._l((t.list), function(_t) {
      return (t.list) ? _c('ul', [_c('li', [_c('a', {
        attrs: {
          "href": '#' + _t.anchor
        }
      }, [_vm._v(_vm._s(_t.title.slice(0, 12)))])])]) : _vm._e()
    })], 2)])
  })), (_vm.needImport) ? [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "install"
    }
  }, [_vm._v("Install")]), _c('h2', [_vm._v("Install")]), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "Local Registration"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "click to copy",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.localImportCode),
      expression: "localImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Spinner } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Spinner\n  }\n}")])])], 1)]), _c('el-tab-pane', {
    attrs: {
      "label": "Global Registration"
    }
  }, [_c('div', {
    staticClass: "import-code-box"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "click to copy",
      "placement": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.globalImportCode),
      expression: "globalImportCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onCopyError),
      expression: "onCopyError",
      arg: "error"
    }]
  }, [_c('el-icon', {
    staticClass: "el-icon-document"
  })], 1)]), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// you can also register globally")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Vue "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Spinner } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'spinner'")]), _vm._v(", Spinner)\n")])])], 1)])], 1)] : [_c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("You don't need to import this component.")])])], (_vm.metas.tip) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e(), (_vm.metas.example) ? _c('h2', [_vm._v("example")]) : _vm._e(), (_vm.metas.example) ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }) : _vm._e()], 2), (_vm.metas.extra && _vm.metas.extra['en']) ? _c('div') : _vm._e(), (_vm.metas.extra && !_vm.metas.extra['en']) ? _c('div') : _vm._e(), (_vm.demos.length) ? _c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "examples"
    }
  }, [_vm._v("Examples")]) : _vm._e(), _c('br'), _vm._l((_vm.demos), function(demo) {
    return (_vm.demos.length) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'examples:' + demo.title
      }
    }, [_vm._v(_vm._s(demo.title))]), _c('br'), _c('div', {
      staticClass: "demo-header"
    }, [_c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))])]), _c('div', {
      staticClass: "demos",
      style: ({
        height: demo.height
      })
    }, [_c('div', {
      staticClass: "demo-iframe-box"
    }, [_c('lazy-component', [_c('iframe', {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "src": _vm.domain + '?no-background-color=' + demo.noBackgroundColor + '&locale=en&transition=none&hide-nav=true&hide-tab-bar=true#/components/' + demo.file,
        "width": "375",
        "height": "600",
        "border": "0",
        "frameborder": "0"
      }
    })], 1)], 1), _c('div', {
      staticClass: "demo-code-box",
      style: ({
        overflow: demo.height === demo.oriHeight ? 'hidden' : 'scroll'
      })
    }, [_c('div', {
      attrs: {
        "contenteditable": ""
      },
      domProps: {
        "innerHTML": _vm._s(demo.code)
      }
    }), (demo.height === demo.oriHeight) ? _c('div', {
      staticClass: "demo-code-masker",
      on: {
        "click": function($event) {
          demo.height = 'auto'
        }
      }
    }, [_c('div', [_c('img', {
      staticClass: "demo-qr",
      attrs: {
        "width": "100",
        "src": 'https://qr.vux.li/api.php?text=' + encodeURIComponent(_vm.domain + '?locale=en#/components/' + demo.file)
      }
    }), _c('br'), _c('span', [_c('el-icon', {
      staticClass: "el-icon-arrow-left"
    }), _c('el-icon', {
      staticClass: "el-icon-arrow-right"
    }), _vm._v("\n                    Show code\n                  "), _c('br')], 1)])]) : _vm._e(), (demo.height === 'auto') ? _c('span', {
      staticClass: "hide-code",
      on: {
        "click": function($event) {
          demo.height = demo.oriHeight
        }
      }
    }, [_c('el-icon', {
      staticClass: "el-icon-close"
    })], 1) : _vm._e()])])] : _vm._e()
  }), _vm._l((_vm.componentList), function(component) {
    return [_c('div', [(_vm.componentList.length > 1) ? _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": 'components:' + component.name
      }
    }, [_vm._v(_vm._s(component.name))]) : _c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "api"
      }
    }, [_vm._v("API")]), _c('br'), _c('h2', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentList.length > 1),
        expression: "componentList.length > 1"
      }],
      staticClass: "vux-component-name-sub-item"
    }, [_vm._v(_vm._s(component.name))]), (component.meta.items && component.meta.description) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(component.meta.description)
      }
    })] : _vm._e(), (component.meta.props) ? [_c('h2', [_vm._v("Props")]), _c('table', [_vm._m(0, true), _c('tbody', _vm._l((component.meta.props), function(prop, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getTypeHTML(prop.type))
        }
      }), _c('td', [_vm._v(_vm._s(prop.default))]), _c('td', {
        domProps: {
          "innerHTML": _vm._s(prop['en'] ? prop['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(prop.version || '--'))])])
    }))])] : _vm._e(), (component.meta.events) ? [_c('h2', [_vm._v("Events")]), _c('table', [_vm._m(1, true), _c('tbody', _vm._l((component.meta.events), function(event, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + i),
          expression: "'@' + i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event.params ? event.params.replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(event['en'] ? event['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '--')
        }
      }), _c('td', [_vm._v(_vm._s(event['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.slots) ? [_c('h2', [_vm._v("Slots")]), _c('table', [_vm._m(2, true), _c('tbody', _vm._l((component.meta.slots), function(slot, i) {
      return _c('tr', {
        class: {
          'slot-disabled': slot['status'] === 'deprecated'
        }
      }, [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i === 'default' ? 'default' : i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(slot['en'] ? slot['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(slot['version'] || '--'))])])
    }))])] : _vm._e(), (component.meta.methods) ? [_c('h2', [_vm._v("Functions")]), _c('table', [_vm._m(3, true), _c('tbody', _vm._l((component.meta.methods), function(method, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (i),
          expression: "i",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v(_vm._s(i))])])], 1), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['params'] ? method['params'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', {
        domProps: {
          "innerHTML": _vm._s(method['en'] ? method['en'].replace(/`(.*?)`/g, '<code>$1</code>') : '')
        }
      }), _c('td', [_vm._v(_vm._s(method['version']))])])
    }))])] : _vm._e(), (component.meta.variables) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "variables"
      }
    }, [_vm._v("Variables")]), _c('br'), _c('h2', [_vm._v("Variables")]), _c('table', [_vm._m(4, true), _c('tbody', _vm._l((component.meta.variables), function(variable, i) {
      return _c('tr', [_c('td', {
        staticClass: "prop-name"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "click to copy",
          "placement": "left",
          "hide-after": 0,
          "open-delay": 50
        }
      }, [_c('span', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: ('@' + variable.name),
          expression: "'@' + variable.name",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopy),
          expression: "onCopy",
          arg: "success"
        }]
      }, [_vm._v("@" + _vm._s(variable.name))])])], 1), _c('td', [(!_vm.$refs['propColor' + i] || (_vm.$refs['propColor' + i][0] && _vm.$refs['propColor' + i][0].style.backgroundColor)) ? _c('em', {
        ref: 'propColor' + i,
        refInFor: true,
        staticClass: "prop-color",
        style: ({
          backgroundColor: variable.value
        })
      }) : _vm._e(), _vm._v("\n                    " + _vm._s(variable.value) + "\n                  ")]), _c('td', [_vm._v(_vm._s(variable['desc']['en'] || '--'))]), _c('td', [_vm._v(_vm._s(variable.inherited_name))])])
    }))])] : _vm._e(), (component.meta.tips && component.meta.tips['en']) ? [_c('a', {
      staticClass: "anchor",
      attrs: {
        "id": "tips"
      }
    }, [_vm._v("Tips")]), _c('br'), _c('h2', [_vm._v("Tips")]), _c('div', [_c('ul', _vm._l((component.meta.tips['en']), function(tip) {
      return _c('li', [_c('el-tag', {
        staticClass: "component-tip-tag",
        attrs: {
          "size": "mini",
          "type": "success"
        }
      }, [_vm._v("Q")]), _c('span', {
        staticClass: "component-tip-question"
      }, [_vm._v(_vm._s(tip.q))]), _c('div', {
        staticClass: "tip-answer-box",
        domProps: {
          "innerHTML": _vm._s(tip.a)
        }
      })], 1)
    }))])] : _vm._e()], 2)]
  }), _c('br'), (_vm.issues.length) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "Issues"
    }
  }, [_vm._v("Issues")]), _c('br'), _c('h2', [_vm._v("Related issues")]), _c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": issue.html_url
      }
    }, [_vm._v("#" + _vm._s(issue.number) + " "), _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(issue.title))])])])
  }))]) : _vm._e(), _c('br'), (_vm.gitMetas) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "contributors"
    }
  }, [_vm._v("Contributors")]), _c('h2', [_vm._v("Contributors")]), _c('p', [_vm._v("Total commits quantity: " + _vm._s(_vm.gitMetas.commitCount) + "，Total contributors quantity: " + _vm._s(_vm.gitMetas.commitUniqueCount) + "\n        ")]), _vm._l((_vm.gitMetas.commitMembers), function(person) {
    return _c('a', {
      staticClass: "contributor-item",
      attrs: {
        "href": 'https://github.com/' + person.authorName,
        "target": "_blank",
        "title": 'contribute' + person.count
      }
    }, [_vm._v(_vm._s(person.authorName))])
  })], 2) : _vm._e(), _c('br'), (_vm.metas.changes) ? _c('div', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "changelog"
    }
  }, [_vm._v("Changelog")]), _c('br'), _c('h2', [_vm._v("Releases")]), (_vm.metas.changes) ? _c('ul', [_vm._l((_vm.metas.changes), function(changelog, version) {
    return _vm._l((changelog['en']), function(log) {
      return _c('li', [_c('router-link', {
        staticClass: "changelog-version",
        attrs: {
          "to": '/en/changelog/' + version + '.html'
        }
      }, [_vm._v(_vm._s(version))]), _vm._v(" " + _vm._s(log) + "\n            ")], 1)
    })
  })], 2) : _vm._e()]) : _vm._e(), (_vm.metas.references) ? _c('h2', [_vm._v("Referrences")]) : _vm._e(), (_vm.metas.references) ? _c('ul', _vm._l((_vm.metas.references['en']), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))])])
  })) : _vm._e(), _c('el-dialog', {
    staticClass: "sourcec-code-dialog",
    attrs: {
      "top": "0",
      "width": "80%",
      "visible": _vm.sourceCodeDialogVisibility
    },
    on: {
      "update:visible": function($event) {
        _vm.sourceCodeDialogVisibility = $event
      }
    }
  }, [_c('div', {
    staticClass: "code-box",
    attrs: {
      "contenteditable": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.demoCode)
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', {
    staticStyle: {
      "width": "48px"
    }
  }, [_vm._v("type")]), _c('td', [_vm._v("default")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("params")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("params")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("required version")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("name")]), _c('td', [_vm._v("default")]), _c('td', [_vm._v("description")]), _c('td', [_vm._v("inherited name")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64810180", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-64810180","preserveWhitespace":false}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./en/components/spinner.vue
// module id = 2295
// module chunks = 114